import { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import { IGetTiDuties, IGroup, ITiDuty } from '../../../models/groups.model';
import Button from '../../Button';
import Radio from '../../Radio';
import { Descriptions, Select } from 'antd';
import useAuth from '../../../hooks/useAuth';
import useAxios from '../../../hooks/useAxios';
import { getTiDuties } from '../../../api/groups.api';
import useNotification from '../../../hooks/useNotification';
import Loader from '../../Loader';
import ErrorResponse from '../../ErrorResponse';

interface IProps {
  group: IGroup | null;
  onSubmit: Function;
}

const SystemGroupEditor: FC<IProps> = ({
  group,
  onSubmit,
}) => {
  const { writeAuthYn } = useAuth();
  const { i18n, t } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // MB0001 = 그룹 권한 유형
  const MB0001 = commonCodes.find(item => item.commonCode === 'MB0001')?.detailCode;
  const history = useHistory();
  const { infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetTiDuties>();

  const [korName, setKorName] = useState('');
  const [engName, setEngName] = useState('');
  const [authGroup, setAuthGroup] = useState<any>();
  const [authGroupList, setAuthGroupList] = useState<any>();
  const [personDutyCode, setPersonDutyCode] = useState<string>();
  const [hqYn, setHqYn] = useState(false);

  const korNameInput = useRef<any>();
  const engNameInput = useRef<any>();

  useEffect(() => {
    execute(getTiDuties());
  }, []);

  useEffect(() => {
    if (MB0001) {
      const _authGroupList: any = [];
      MB0001.forEach(item => {
        _authGroupList.push({
          label: i18n.language === 'ko' ? item.korName : item.engName,
          value: item.detailCode
        });
      });
      setAuthGroupList(_authGroupList);
    }
  }, [commonCodes]);

  useEffect(() => {
    if (group) {
      setKorName(group.korName);
      setEngName(group.engName);
      setAuthGroup(group.authGroupDiv);
      setPersonDutyCode(group.personDutyCode);
      setHqYn(group.hqYn === 'Y');
    }
  }, [group]);

  const onSave = async () => {
    if (!korName) {
      return infoNotification(t('system.group.message1'));
    }
    if (!engName) {
      return infoNotification(t('system.group.message2'));
    }
    if (!authGroup) {
      return infoNotification(t('system.group.message3'));
    }
    if (!personDutyCode) {
      return infoNotification(t('system.group.message4'));
    }

    onSubmit({
      korName,
      engName,
      authGroupDiv: authGroup,
      personDutyCode,
      hqYn: hqYn ? 'Y' : 'N'
    })
  };

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <div className='comm-table__area rowType edit'>
        <Descriptions bordered size="small" column={1}>
          <Descriptions.Item label={t('system.group.column2')}>
            <input
              type="text"
              className="form-control input-text"
              value={korName}
              onChange={e => setKorName(e.target.value)}
              ref={korNameInput}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('system.group.column3')}>
            <input
              type="text"
              className="form-control input-text"
              value={engName}
              onChange={e => setEngName(e.target.value)}
              ref={engNameInput}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('system.group.column4')}>
            <div className="w-150p">
              <Select
                className="w-100"
                value={authGroup}
                onChange={value => setAuthGroup(value)}
              >
                {
                  authGroupList?.map((item: any) => {
                    return (
                      <Select.Option
                        key={item.value}
                        value={item.value}
                      >
                        {item.label}
                      </Select.Option>
                    )
                  })
                }
              </Select>
            </div>
          </Descriptions.Item>
          <Descriptions.Item label={t('system.group.column6')}>
            <div className="w-150p">
              <Select
                className="w-100"
                value={personDutyCode}
                onChange={value => setPersonDutyCode(value)}
              >
                {
                  res?.data?.map((item: ITiDuty) => {
                    return (
                      <Select.Option
                        key={item.personDutyCode}
                        value={item.personDutyCode}
                      >
                        {item.personDutyName}
                      </Select.Option>
                    )
                  })
                }
              </Select>
            </div>
          </Descriptions.Item>
          <Descriptions.Item label={t('system.group.column5')}>
            <Radio
              checked={hqYn}
              onChange={() => setHqYn(true)}
              text={t('common.option.yes')}
            />
            <Radio
              className="ml-4"
              checked={!hqYn}
              onChange={() => setHqYn(false)}
              text={t('common.option.no')}
            />
          </Descriptions.Item>
        </Descriptions>
      </div>
      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            onClick={onSave}
            className="btn-basic pink"
            text={t('common.button.save')}
            writeAuthYn={writeAuthYn}
          />
          <Button
            onClick={() => history.push('/system/group')}
            className="btn-basic gray"
            text={t('common.button.cancel')}
          />
        </div>
      </div>
    </>
  )
}

export default SystemGroupEditor;
